import React, { forwardRef, useEffect, useState } from "react";
import { DailyLog, CultivationEvent, Category, EventCategories, Varieties } from '../../models';
import { DataStore } from 'aws-amplify';
import { StyleSheet, Text, TouchableOpacity, View, TextInput, Image, SafeAreaView, ScrollView } from 'react-native';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import { categoryItems, categoryEventItems } from '../components/AppConst';
import * as CmnUtil from '../components/CmnUtil';
import IconImages from '../components/IconImages';
import * as CmnDiaLog from '../components/CmnDiaLog';
import { useIsFocused } from '@react-navigation/native';
import { getStorage } from '../components/SessionStorage';
import SwitchSelector from "react-native-switch-selector";
// @ts-ignore
import { MultipleSelectPicker } from 'react-native-multi-select-picker';

/** ================================
*  作業日誌編集画面
*  ================================*/
const DiaryEdit = ({ route, navigation }: { route: any, navigation: any; }) => {
  // 作業日誌/イベント切り替え[dailyLog: 作業日誌, event: イベント]
  const [type, setType] = useState("dailyLog");

  // 圃場
  const [farmList, setFarmList] = useState(route.params["farm"]);
  const [selectFarm, setSelectFarm] = useState(route.params["farm"][0]);

  // 作業日付
  const [selectDate, setSelectDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [finishDate, setFinishDate] = useState(new Date());

  // 作業日誌
  const [diaryData, setDiaryData] = useState(route.params["diary"]);

  // カテゴリーリスト
  const [selectCategory, setSelectCategory] = useState({ label: "選択してください", value: "default" });
  const [selectEventCategory, setSelectEventCategory] = useState({ label: "選択してください", value: "default" });

  // 入力データ
  const [diaryLogId, setDiaryLogId] = useState("");
  const [memo, setMemo] = useState("");
  const [workingHour, setWorkingHour] = useState("");
  const [workingMinute, setWorkingMinute] = useState("");
  const [othersInput, setOhersInput] = useState("");
  const [othersEventInput, setOhersEventInput] = useState("");

  // カテゴリ表示
  const [categoryDisp, setCategoryDisp] = useState(false);
  const [categoryEventDisp, setCategoryEventDisp] = useState(false);

  // 圃場表示
  const [farmDisp, setFarmDisp] = useState(false);

  // 画面切替フラグ(Edit:編集 Create:新規作成)
  const [dispType, setDispType] = useState(route.params["type"]);

  // 保存ダイアログ表示フラグ
  const [ismodal, setIsModal] = useState(false);

  // データ処理制御フラグ
  const [actionFlg, setActionFlg] = useState("");

  // フォーカス
  const isFocused = useIsFocused();

  // 栽培品種選択肢
  const [items, setItems] = useState<{ label: string; value: string; }[]>([]);
  // 栽培品種選択開閉
  const [pickerOpen, setPickerOpen] = useState(false);
  // 選択栽培品種
  const [selectectedItems, setSelectectedItems] = useState<{ label: string; value: string; }[]>([]);

  useEffect(() => {
    // 作業日誌編集
    if (diaryData !== undefined) {
      init();
    } else {
      initCreate();
    }
  }, [isFocused]);

  // 選択栽培品種再設定
  useEffect(() => {
    const tmpVarieties = [];
    if (selectFarm.varieties) {
      for (const variety of selectFarm.varieties) {
        if (variety) {
          tmpVarieties.push({ label: CmnUtil.varietiesCnv(variety), value: variety });
        }
      }
    }
    setItems(tmpVarieties);
  }, [selectFarm]);

  /**
   * 画面初期化処理
   */
  const init = async () => {
    const diaryDate = await getStorage('diaryDate');
    const id = diaryData.id ? diaryData.id : "";

    const kind = route.params["kind"];
    setType(kind);

    if (kind == "dailyLog") {
      const workingTime = diaryData.workingTime ? diaryData.workingTime : "";
      var calcTime = Number(workingTime);
      var hour = Math.floor(calcTime / 60);
      var min = calcTime % 60;
      setWorkingHour(hour.toString());
      setWorkingMinute(min.toString());
      const workMemo = diaryData.workMemo ? diaryData.workMemo : "";
      setMemo(workMemo);
      const category = diaryData.category ? diaryData.category : "";
      categoryItems.map((item) => {
        if (item.value === category) {
          setSelectCategory(item);
        }
      });
      const other = diaryData.categoryOptional ? diaryData.categoryOptional : "";
      setOhersInput(other);
      const date = diaryData.date ? CmnUtil.formatToDate(diaryData.date) : diaryDate;
      setSelectDate(date);
    } else {
      const workMemo = diaryData.memo ? diaryData.memo : "";
      setMemo(workMemo);
      const category = diaryData.eventCategory ? diaryData.eventCategory : "";
      categoryEventItems.map((item) => {
        if (item.value === category) {
          setSelectEventCategory(item);
        }
      });
      const other = diaryData.eventCategoryOptional ? diaryData.eventCategoryOptional : "";
      setOhersEventInput(other);
      const startDate = diaryData.startDate ? CmnUtil.formatToDate(diaryData.startDate) : diaryDate;
      setStartDate(startDate);
      const finishDate = diaryData.finishDate ? CmnUtil.formatToDate(diaryData.finishDate) : diaryDate;
      setFinishDate(finishDate);
    }

    setDiaryLogId(id);

    if (diaryData.farm) {
      setSelectFarm(diaryData.farm);
      const tmpVarieties = [];
      if (diaryData.varieties) {
        for (const variety of diaryData.varieties) {
          if (variety) {
            tmpVarieties.push({ label: CmnUtil.varietiesCnv(variety), value: variety });
          }
        }
      }
      setSelectectedItems(tmpVarieties);
    }

  };

  /**
   * 新規作成画面初期化
   */
  const initCreate = async () => {
    const diaryDate = await getStorage('diaryDate');
    setSelectDate(CmnUtil.formatToDate(diaryDate));
    setStartDate(CmnUtil.formatToDate(diaryDate));
    setFinishDate(CmnUtil.formatToDate(diaryDate));
  };

  /**
   * モーダル表示・データ処理制御
   */
  const handleModeAction = (saveFlg: string) => {
    setActionFlg(saveFlg);
    setIsModal(!ismodal);
  };

  /**
   * 作業日誌処理制御
   */
  const saveDiaryAction = async () => {
    await saveDiary().then((result) => {
      setIsModal(!ismodal);

      if (result["status"] == "success") {
        CmnUtil.appMsg(result['message']);
      } else {
        CmnUtil.appAlert(result['message']);
      }

      window.setTimeout(() => {
        if (result["status"] == "success") {
          navigation.goBack();
        }
      }, 2500);
    });
  };

  /**
   * 作業日誌更新
   */
  const saveDiary = async () => {
    var saveParam: { [key: string]: any; } = {};
    var resultParam: { [key: string]: any; } = {};
    try {
      // 制御フラグがDeleteの場合、削除処理へ
      if (actionFlg == "Delete") {
        // 作業日誌削除
        await deleteDailyLog().then(() => {
          resultParam["status"] = "success";
          resultParam["message"] = "削除に成功しました。";
        });
      } else {
        // カテゴリー値セット
        saveParam['categoryOptional'] = null;
        saveParam['category'] = selectCategory.value;
        if (selectCategory.value == Category.OTHERS) {
          saveParam['categoryOptional'] = othersInput;
        }

        saveParam['eventCategoryOptional'] = null;
        saveParam['eventCategory'] = selectEventCategory.value;
        if (selectEventCategory.value == EventCategories.OTHERS) {
          saveParam['eventCategoryOptional'] = othersEventInput;
        }

        saveParam['workingTime'] = (Number(workingHour) * 60) + Number(workingMinute);
        saveParam['farm'] = selectFarm;
        saveParam['date'] = CmnUtil.formatDate(selectDate);
        saveParam['startDate'] = CmnUtil.formatDate(startDate);
        saveParam['finishDate'] = CmnUtil.formatDate(finishDate);
        saveParam['workMemo'] = memo;
        saveParam['varieties'] = selectectedItems.map((item) => { return item.value as Varieties });
        saveParam['id'] = diaryLogId;

        if (type == "dailyLog") {
          if (saveParam['category'] == "default") {
            resultParam["status"] = "error";
            resultParam["message"] = "カテゴリーは必須入力です。";
            return resultParam;
          }
        } else {
          if (saveParam['eventCategory'] == "default") {
            resultParam["status"] = "error";
            resultParam["message"] = "カテゴリーは必須入力です。";
            return resultParam;
          }
          if (saveParam['startDate'] > saveParam['finishDate']) {
            resultParam["status"] = "error";
            resultParam["message"] = "終了日付には開始日付以降を選択してください。";
            return resultParam;
          }
        }

        // idがセットされていたら更新
        if (diaryLogId) {
          await updateDailyLog(saveParam).then(() => {
            resultParam["status"] = "success";
            resultParam["message"] = "更新に成功しました。";
          });
        } else {
          await createDailyLog(saveParam).then(() => {
            resultParam["status"] = "success";
            resultParam["message"] = "作成に成功しました。";
          });
        }
      }
      return resultParam;
    } catch (error) {
      // エラーダイアログ表示
      resultParam["status"] = "error";
      resultParam["message"] = "作業日誌の操作に失敗しました。";
      return resultParam;
    }
  };

  /**
   * 作業日誌を取得
   */
  const queryDailyLog = async () => {
    return DataStore.query(DailyLog, c => c.id("eq", diaryLogId));
  };

  /**
   * イベントを取得
   */
  const queryCultivationEvent = async () => {
    return DataStore.query(CultivationEvent, c => c.id("eq", diaryLogId));
  };

  /**
   * 作業日誌新規作成処理
   */
  const createDailyLog = async (saveParam: any) => {
    const appUser = await CmnUtil.getCurrentUser();
    if (type == "dailyLog") {
      await DataStore.save(new DailyLog({
        farm: saveParam['farm'],
        category: saveParam['category'],
        categoryOptional: saveParam['categoryOptional'],
        date: saveParam['date'],
        workingTime: saveParam['workingTime'],
        workMemo: saveParam['workMemo'],
        varieties: saveParam['varieties'],
        authorID: appUser!.id,
      }));
    } else {
      await DataStore.save(new CultivationEvent({
        farm: saveParam['farm'],
        eventCategory: saveParam['eventCategory'],
        eventCategoryOptional: saveParam['eventCategoryOptional'],
        startDate: saveParam['startDate'],
        finishDate: saveParam['finishDate'],
        memo: saveParam['workMemo'],
        authorID: appUser!.id,
        varieties: saveParam['varieties'],
      }));
    }
  };

  /**
   * 作業日誌更新処理
   */
  const updateDailyLog = async (saveParam: any) => {
    if (type == "dailyLog") {
      const original = await queryDailyLog();
      await DataStore.save(
        DailyLog.copyOf(original[0], updated => {
          updated.farm = saveParam['farm'];
          updated.category = saveParam['category'];
          updated.categoryOptional = saveParam['categoryOptional'];
          updated.date = saveParam['date'];
          updated.workingTime = saveParam['workingTime'];
          updated.workMemo = saveParam['workMemo'];
          updated.varieties = saveParam['varieties'];
        })
      );
    } else {
      const original = await queryCultivationEvent();
      await DataStore.save(
        CultivationEvent.copyOf(original[0], updated => {
          updated.farm = saveParam['farm'];
          updated.eventCategory = saveParam['eventCategory'];
          updated.eventCategoryOptional = saveParam['eventCategoryOptional'];
          updated.startDate = saveParam['startDate'];
          updated.finishDate = saveParam['finishDate'];
          updated.memo = saveParam['workMemo'];
          updated.varieties = saveParam['varieties'];
        })
      );
    }
  };

  /**
   * 作業日誌削除処理
   */
  const deleteDailyLog = async () => {
    if (type == "dailyLog") {
      const dailyLog = await queryDailyLog();
      DataStore.delete(dailyLog[0]);
    } else {
      const cultivationEvent = await queryCultivationEvent();
      DataStore.delete(cultivationEvent[0]);
    }
  };

  /** 
   * カテゴリー表示レイアウト
   */
  const getCategoryStyle = (category: any) => {
    switch (category) {
      case Category.FLOWERING:
        return { backgroundColor: "#FFCACA" };
      case Category.PESTICIDE_SPRAYNING:
        return { backgroundColor: "#FDEFE6" };
      case Category.FRUITS_THINNING:
        return { backgroundColor: "#EBF3FA" };
      case Category.MATING:
        return { backgroundColor: "#FFFBF0" };
      case Category.HARVEST:
        return { backgroundColor: "#E2CFF1" };
      case Category.OTHERS:
        return { backgroundColor: "#F4F4F4" };
      default:
        return { backgroundColor: "#F4F4F4" };
    }
  };
  const getEventCategoryStyle = (category: any) => {
    switch (category) {
      case EventCategories.FLOWERING:
        return { backgroundColor: "#FFCACA" };
      case EventCategories.PESTICIDE_SPRAYNING:
        return { backgroundColor: "#FDEFE6" };
      case EventCategories.FRUITS_THINNING:
        return { backgroundColor: "#EBF3FA" };
      case EventCategories.MATING:
        return { backgroundColor: "#FFFBF0" };
      case EventCategories.HARVEST:
        return { backgroundColor: "#E2CFF1" };
      case EventCategories.OTHERS:
        return { backgroundColor: "#F4F4F4" };
      default:
        return { backgroundColor: "#F4F4F4" };
    }
  };

  /**
   * カテゴリー表示
   */
  const isCategoryDisp = () => {
    setCategoryDisp(!categoryDisp);
  };
  const isCategoryEventDisp = () => {
    setCategoryEventDisp(!categoryEventDisp);
  };

  /**
   * カテゴリー選択
   */
  const setCategory = (item: any) => {
    setSelectCategory(item);
    isCategoryDisp();
  };
  const setEventCategory = (item: any) => {
    setSelectEventCategory(item);
    isCategoryEventDisp();
  };

  /**
   * 圃場表示
   */
  const isFarmDisp = () => {
    setFarmDisp(!farmDisp);
  };

  /**
   * 圃場選択
   */
  const setFarm = (item: any) => {
    if (selectFarm.id != item.id) {
      setSelectFarm(item);
      setSelectectedItems([]);
    }
    isFarmDisp();
  };

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: "#E2F0D9",
    },
    headerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 20,
      marginBottom: 20,
    },
    scheduleForm: {
      borderColor: "#83A3BF",
      borderWidth: 2,
      borderStyle: "solid",
      backgroundColor: "#ffffff"
    },
    scheduleBlock: {
      padding: 10,
      width: "100%",
      height: 50,
      flexDirection: "row",
      alignItems: "center",
      borderColor: "#83A3BF",
      borderBottomWidth: 2,
      borderStyle: "solid",
    },
    formText: {
      fontSize: 18,
      width: "30%",
    },
    formInput: {
      fontSize: 18,
      height: 40,
      padding: 5
    },
    timeInput: {
      flexDirection: "row",
      alignItems: "center",
      width: "70%",
    },
    memo: {
      height: 200,
      padding: 10,
      lineHeight: 20,
      fontSize: 18
    },
    dropDownArea: {
      flexDirection: 'row',
      width: "70%",
    },
    deleteDailyView: {
      marginVertical: 50,
      marginHorizontal: "auto",
    },
    deleteDaily: {
      color: "#ff0000",
      fontSize: 18,
      textDecorationLine: "underline",
      textAlign: "center",
    },
  });

  /** 
   * ヘッダーレイアウト 
   */
  const headerStyles = StyleSheet.create({
    headerText: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: 18
    },
    button: {
      backgroundColor: "#7AAD47",
      borderWidth: 1,
      borderColor: "#057E32",
      borderStyle: "solid",
      width: 120,
      marginHorizontal: 10,
      shadowColor: "#808080",
      shadowOffset: { width: 5, height: 5 },
      shadowRadius: 10
    },
    buttonText: {
      color: "#ffffff",
      textAlign: "center",
      fontSize: 18
    },
  });

  /**
   * カテゴリーレイアウト
   */
  const categoryStyles = StyleSheet.create({
    categoryText: {
      width: "80%",
      fontSize: 18,
      color: "#7F7F7F",
      textAlign: "center",
    },
    categoryItems: {
      display: categoryDisp ? "flex" : "none",
      position: "absolute",
      top: 50,
      zIndex: categoryDisp ? 100 : -1,
      width: "100%",
    },
    categoryEventItems: {
      display: categoryEventDisp ? "flex" : "none",
      position: "absolute",
      top: 50,
      zIndex: categoryEventDisp ? 100 : -1,
      width: "100%",
    },
    farmItems: {
      display: farmDisp ? "flex" : "none",
      position: "absolute",
      top: 100,
      zIndex: farmDisp ? 100 : -1,
      width: "100%",
    },
    varietiesItems: {
      display: pickerOpen ? "flex" : "none",
      position: "absolute",
      top: (selectectedItems.length > 2 ? 200 + selectectedItems.length * 27 : 250) + (type == "dailyLog" ? 0 : 50),
      zIndex: pickerOpen ? 100 : -1,
      width: "100%",
    },
    farmItem: {
      width: "100%",
      alignItems: 'center',
      borderColor: "#83A3BF",
      borderStyle: "solid",
      borderBottomWidth: 2,
      backgroundColor: "#f0f8ff",
    },
    farmItemText: {
      fontSize: 18,
    },
    modal: {
      position: "absolute",
      backgroundColor: "#ffffff",
      height: "100%",
    },
    selectCategory: {
      width: "100%",
      alignItems: 'center',
    },
    selectCategoryText: {
      fontSize: 18,
    },
    othersView: {
      flexDirection: "row",
      justifyContent: 'center',
    },
    othersCategory: {
      width: "40%",
      alignItems: 'center',
    },
    othersInputView: {
      width: "60%",
      backgroundColor: "#F4F4F4",
    },
    othersInput: {
      fontSize: 18,
      backgroundColor: "#ffffff",
      borderColor: "#83A3BF",
      borderWidth: 2,
      borderStyle: "solid",
      textAlign: "center"
    },
  });

  /**
   * 作業時間レイアウト
   */
  const workHourtStyles = StyleSheet.create({
    workHourt: {
      fontSize: 18,
      height: 40,
      padding: 5,
      width: 40,
      borderColor: "#83A3BF",
      borderWidth: 2,
      borderStyle: "solid",
      marginHorizontal: 5,
      textAlign: "center"
    },
    workMinutes: {
      fontSize: 18,
      height: 40,
      padding: 5,
      width: 50,
      borderColor: "#83A3BF",
      borderWidth: 2,
      borderStyle: "solid",
      marginHorizontal: 5,
      textAlign: "center"
    },
  });

  const iconStyles = StyleSheet.create({
    categoryDispIcon: {
      width: 30,
      height: 30,
      transform: [{ scaleX: categoryDisp ? -1 : 1 }, { scaleY: categoryDisp ? -1 : 1 }]
    },
    categoryEventDispIcon: {
      width: 30,
      height: 30,
      transform: [{ scaleX: categoryEventDisp ? -1 : 1 }, { scaleY: categoryEventDisp ? -1 : 1 }]
    },
    farmDispIcon: {
      width: 30,
      height: 30,
      transform: [{ scaleX: farmDisp ? -1 : 1 }, { scaleY: farmDisp ? -1 : 1 }]
    },
    varietyDispIcon: {
      width: 30,
      height: 30,
      transform: [{ scaleX: pickerOpen ? -1 : 1 }, { scaleY: pickerOpen ? -1 : 1 }]
    },
  });

  /**
   * 切り替えレイアウト
   */
  const switchSelectorStyles = StyleSheet.create({
    selectorView: {
      flexDirection: "row",
      alignItems: 'center',
      justifyContent: 'center',
    },
    selector: {
      width: "50%",
    },
  });

  // 日付選択Picker
  const CustomDatePicker = ({
    onChange,
    selected,
  }: {
    onChange: Function;
    selected: Date;
  }) => {
    // @ts-ignore
    const CustomInput = forwardRef(({ onClick }, ref) => (
      <TouchableOpacity onPress={onClick}>
        <Text style={styles.formInput}>
          {CmnUtil.formatDateAndWeek(selected)}
        </Text>
      </TouchableOpacity>
    ));

    return (
      <DatePicker
        locale={ja}
        selected={selected}
        onChange={(date) => onChange(date!)}
        customInput={<CustomInput />}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <View
            style={{
              padding: 10,
              flexDirection: "row",
              width: "fitContent",
            }}
          >
            <TouchableOpacity
              onPress={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              <Text style={{ fontSize: 22, fontWeight: "bold" }}>&lt;</Text>
            </TouchableOpacity>
            <View style={{ flexDirection: "row", marginHorizontal: "auto" }}>
              <Text style={{ fontSize: 22, fontWeight: "bold" }}>
                {date.getFullYear()}年
              </Text>
              <Text style={{ fontSize: 22, fontWeight: "bold" }}>
                {date.getMonth() + 1}月
              </Text>
            </View>
            <TouchableOpacity
              onPress={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              <Text style={{ fontSize: 22, fontWeight: "bold" }}>&gt;</Text>
            </TouchableOpacity>
          </View>
        )}
        dateFormat="yyyy年MM月dd日"
      />
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView>
        <CmnDiaLog.SaveDialog
          cancelButtonName="キャンセル"
          saveButtonName={actionFlg == "Delete" ? "削除" : "保存"}
          message={actionFlg == "Delete" ? "削除しますか？" : "変更を保存しますか？"}
          visible={ismodal}
          canceAction={() => { setIsModal(!ismodal); }}
          saveAction={() => { saveDiaryAction(); }}
        />
        <View style={styles.headerContainer}>
          <TouchableOpacity style={headerStyles.button} onPress={() => navigation.goBack()}>
            <Text style={headerStyles.buttonText}>キャンセル</Text>
          </TouchableOpacity>
          <Text style={headerStyles.headerText}>{dispType === "Edit" ? "編集" : "新規作成"}</Text>
          <TouchableOpacity style={headerStyles.button} onPress={() => handleModeAction("Edit")}>
            <Text style={headerStyles.buttonText}>保存</Text>
          </TouchableOpacity>
        </View>

        <View style={switchSelectorStyles.selectorView}>
          <SwitchSelector
            initial={0}
            value={type == "dailyLog" ? 0 : 1}
            onPress={(type: string) => { setType(type) }}
            textColor="#ffffff"
            selectedColor="#ffffff"
            buttonColor="#5B9BD5"
            borderColor="#909090"
            backgroundColor="#808080"
            borderRadius={0}
            style={{ width: "100%", padding: 5 }}
            hasPadding
            options={[
              {
                label: "作業記録",
                value: "dailyLog",
              },
              {
                label: "イベント",
                value: "event"
              },
            ]}
            disabled={diaryData != undefined}
          />
        </View>

        <View style={styles.scheduleForm}>
          {type == "dailyLog" ?
            <>
              <View style={styles.scheduleBlock}>
                <Text style={styles.formText}>カテゴリー</Text>
                <View style={styles.dropDownArea}>
                  <Text style={categoryStyles.categoryText}>
                    {selectCategory.label}
                    {
                      selectCategory.value == Category.OTHERS && othersInput ?
                        "[" + othersInput + "]"
                        : ""
                    }
                  </Text>
                  <TouchableOpacity onPress={isCategoryDisp}>
                    <Image style={iconStyles.categoryDispIcon} source={IconImages.icDownArrowCircle} />
                  </TouchableOpacity>
                </View>
              </View>
              <View style={categoryStyles.categoryItems}>
                {
                  categoryItems.map((item, index) => {
                    return (
                      item.value === 'others' ?
                        <View key={index} style={categoryStyles.othersView}>
                          <TouchableOpacity
                            style={[getCategoryStyle(item.value), categoryStyles.othersCategory]}
                            activeOpacity={0.8}
                            onPress={() => setCategory(item)}>
                            <Text style={categoryStyles.selectCategoryText}>{item.label}</Text>
                          </TouchableOpacity>
                          <View style={categoryStyles.othersInputView}>
                            <TextInput style={categoryStyles.othersInput} value={othersInput} onChangeText={
                              (text) => {
                                setSelectCategory({ label: "その他", value: "others" });
                                setOhersInput(text);
                              }
                            } />
                          </View>
                        </View>
                        :
                        <View key={index}>
                          <TouchableOpacity
                            activeOpacity={0.8}
                            style={[getCategoryStyle(item.value), categoryStyles.selectCategory]}
                            onPress={() => setCategory(item)}>
                            <Text style={categoryStyles.selectCategoryText}>{item.label}</Text>
                          </TouchableOpacity>
                        </View>
                    );
                  })
                }
              </View>
            </>
            :
            <>
              <View style={styles.scheduleBlock}>
                <Text style={styles.formText}>カテゴリー</Text>
                <View style={styles.dropDownArea}>
                  <Text style={categoryStyles.categoryText}>
                    {selectEventCategory.label}
                    {
                      selectEventCategory.value == EventCategories.OTHERS && othersEventInput ?
                        "[" + othersEventInput + "]"
                        : ""
                    }
                  </Text>
                  <TouchableOpacity onPress={isCategoryEventDisp}>
                    <Image style={iconStyles.categoryEventDispIcon} source={IconImages.icDownArrowCircle} />
                  </TouchableOpacity>
                </View>
              </View>
              <View style={categoryStyles.categoryEventItems}>
                {
                  categoryEventItems.map((item, index) => {
                    return (
                      item.value === 'others' ?
                        <View key={index} style={categoryStyles.othersView}>
                          <TouchableOpacity
                            style={[getEventCategoryStyle(item.value), categoryStyles.othersCategory]}
                            activeOpacity={0.8}
                            onPress={() => setEventCategory(item)}>
                            <Text style={categoryStyles.selectCategoryText}>{item.label}</Text>
                          </TouchableOpacity>
                          <View style={categoryStyles.othersInputView}>
                            <TextInput style={categoryStyles.othersInput} value={othersEventInput} onChangeText={
                              (text) => {
                                setSelectEventCategory({ label: "その他", value: "others" });
                                setOhersEventInput(text);
                              }
                            } />
                          </View>
                        </View>
                        :
                        <View key={index}>
                          <TouchableOpacity
                            activeOpacity={0.8}
                            style={[getEventCategoryStyle(item.value), categoryStyles.selectCategory]}
                            onPress={() => setEventCategory(item)}>
                            <Text style={categoryStyles.selectCategoryText}>{item.label}</Text>
                          </TouchableOpacity>
                        </View>
                    );
                  })
                }
              </View>
            </>}
          <View style={styles.scheduleBlock}>
            <Text style={styles.formText}>圃場</Text>
            <View style={styles.dropDownArea}>
              <Text style={categoryStyles.categoryText}>{selectFarm.name}</Text>
              <TouchableOpacity onPress={isFarmDisp}>
                <Image style={iconStyles.farmDispIcon} source={IconImages.icDownArrowCircle} />
              </TouchableOpacity>
            </View>
          </View>
          <View style={categoryStyles.farmItems}>
            {
              farmList.map((item: any, index: number) => {
                return (
                  <View key={index} >
                    <TouchableOpacity
                      activeOpacity={0.8}
                      style={categoryStyles.farmItem}
                      onPress={() => setFarm(item)}>
                      <Text style={categoryStyles.farmItemText}>{item.name}</Text>
                    </TouchableOpacity>
                  </View>
                );
              })
            }
          </View>
          {type == "dailyLog" ?
            <>
              <View style={styles.scheduleBlock}>
                <Text style={styles.formText}>日付</Text>
                <Text style={styles.formInput}>{CmnUtil.formatDateAndWeek(selectDate)}</Text>
              </View>
              <View style={styles.scheduleBlock}>
                <Text style={styles.formText}>作業時間</Text>
                <View style={styles.timeInput}>
                  <TextInput
                    style={workHourtStyles.workHourt}
                    keyboardType="number-pad"
                    onChangeText={(text) => {
                      setWorkingHour(isNaN(Number(text)) ? workingHour : text);
                    }}
                    value={workingHour}
                    returnKeyType={'done'}
                  ></TextInput>
                  <Text style={styles.formText}>時間</Text>
                  <TextInput
                    style={workHourtStyles.workMinutes}
                    keyboardType="number-pad"
                    onChangeText={(text) => {
                      if (isNaN(Number(text)) || Number(text) > 59) {
                        setWorkingMinute(workingMinute);
                      } else {
                        setWorkingMinute(text);
                      }
                    }}
                    value={workingMinute}
                    returnKeyType={'done'}
                  ></TextInput>
                  <Text style={styles.formText}>分</Text>
                </View>
              </View>
            </>
            :
            <>
              <View style={[styles.scheduleBlock, { zIndex: 4 }]}>
                <Text style={styles.formText}>開始日付</Text>
                <View style={{ width: "70%" }}>
                  <CustomDatePicker
                    onChange={setStartDate}
                    selected={new Date(startDate)}
                  />
                </View>
              </View>
              <View style={[styles.scheduleBlock, { zIndex: 3 }]}>
                <Text style={styles.formText}>終了日付</Text>
                <View style={{ width: "70%" }}>
                  <CustomDatePicker
                    onChange={setFinishDate}
                    selected={new Date(finishDate)}
                  />
                </View>
              </View>
            </>}
          <View style={[styles.scheduleBlock, selectectedItems.length > 2 ? { height: selectectedItems.length * 27 } : {}]}>
            <Text style={styles.formText}>品種</Text>
            <View style={[categoryStyles.categoryText, { width: "56%" }]}>
              {selectectedItems.length == 0 ?
                <Text style={[categoryStyles.categoryText, { width: "100%" }]}>選択してください</Text>
                :
                selectectedItems.map((item, index) => { return (<Text key={index} style={[categoryStyles.categoryText, { width: "100%" }]}>{item["label"]}</Text>) })
              }
            </View>
            <TouchableOpacity onPress={() => { setPickerOpen(!pickerOpen) }}>
              <Image style={iconStyles.varietyDispIcon} source={IconImages.icDownArrowCircle} />
            </TouchableOpacity>
          </View>
          <View style={categoryStyles.varietiesItems}>
            <MultipleSelectPicker
              items={items}
              onSelectionsChange={(ele: any) => { setSelectectedItems(ele); }}
              selectedItems={selectectedItems}
              checkboxStyle={{ height: 20, width: 20 }}
              selectedCheckboxSource={IconImages.icCheckOn}
            />
          </View>
          <View>
            <TextInput
              multiline
              numberOfLines={4}
              editable
              style={styles.memo}
              placeholder="メモ"
              value={memo} onChangeText={setMemo}
            />
          </View>
        </View>
        {dispType === "Edit" ?
          <View style={styles.deleteDailyView}>
            <TouchableOpacity onPress={() => handleModeAction("Delete")}>
              <Text style={styles.deleteDaily}>削除する</Text>
            </TouchableOpacity>
          </View>
          : <></>
        }
      </ScrollView>
    </SafeAreaView>
  );
};


export default DiaryEdit;